import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  AppBar,
  Box,
  Container,
  IconButton,
  Paper,
  Toolbar,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const ShippingPolicyPage = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Box>
      <AppBar position="static" color="default" elevation={1}>
        <Toolbar>
          <IconButton edge="start" onClick={handleBack}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" sx={{ ml: 1 }}>
            Shipping Policy
          </Typography>
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
        <Paper elevation={2} sx={{ p: 3 }}>
          <Typography
            variant="body1"
            component="div"
            sx={{ whiteSpace: "pre-line" }}
          >
            Shipping Policy Nationwide Delivery RAJDHANI RETAIL!proudly offers
            shipping services to customers across India. Whether you're in a
            bustling metropolitan city or a serene rural town, we'll deliver
            your products right to your doorstep. Free Standard Shipping Enjoy
            the convenience of free standard shipping on all orders. No matter
            the size of your purchase, RAJDHANI RETAIL, covers the shipping
            costs to ensure that your grocery essentials reach you without any
            additional fees. Prompt Delivery We understand that your product
            well-being is a top priority. Our standard shipping typically takes
            4-5 days to deliver your order to your location. Rest assured, we
            strive to get your products to you as swiftly as possible. Express
            Delivery For those in need of even faster delivery, RAJDHANI
            RETAIL,offers an express delivery option at an extra charge. To opt
            for this service during checkout, contact us on WhatsApp. Order
            Tracking To keep you informed every step of the way, we provide
            order-tracking services. Once your order is dispatched, you'll
            receive a tracking number, allowing you to monitor your shipment's
            progress until it reaches your doorstep. Shipping Confirmation After
            your order is successfully placed, you'll receive a shipping
            confirmation email with details about your order and estimated
            delivery times. If you've chosen express delivery, you'll receive
            additional information regarding the expedited service. Contact
            Us:-cheerag@rajdhaniretail.in Should you have any questions or
            require further assistance regarding our shipping policy, please
            don't hesitate to contact our dedicated customer support team. We're
            here to ensure that your shopping experience with RAJDHANI RETAIL
            we're committed to delivering exceptional RAJDHANI RETAIL products
            promptly and efficiently, so you can focus on what truly matters the
            health and happiness of your furry companions.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default ShippingPolicyPage;
